import { render, staticRenderFns } from "./charge_details.vue?vue&type=template&id=7308343a&"
import script from "./charge_details.vue?vue&type=script&lang=js&"
export * from "./charge_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports